// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CTB8J","infos":"styles_infos__hGYHc"};